import { render, staticRenderFns } from "./BaseList.vue?vue&type=template&id=792f7261&"
import script from "./BaseList.vue?vue&type=script&lang=ts&"
export * from "./BaseList.vue?vue&type=script&lang=ts&"
import style0 from "./BaseList.vue?vue&type=style&index=0&id=792f7261&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports